import React, { createContext, useContext, useState, useCallback } from 'react';

const ToastContext = createContext(null);

export const useToast = () => useContext(ToastContext);

const ICONS = {
  success: { symbol: 'check_circle', bg: 'bg-primary/10', icon: 'text-primary', fill: true },
  error:   { symbol: 'error',        bg: 'bg-error/10',   icon: 'text-error',   fill: true },
  info:    { symbol: 'info',         bg: 'bg-secondary/10', icon: 'text-secondary', fill: false },
  warning: { symbol: 'warning',      bg: 'bg-yellow-100', icon: 'text-yellow-600', fill: true },
};

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  const showToast = useCallback((message, type = 'info', duration = 3500) => {
    const id = Date.now();
    setToasts(prev => [...prev, { id, message, type }]);
    setTimeout(() => setToasts(prev => prev.filter(t => t.id !== id)), duration);
  }, []);

  const dismiss = (id) => setToasts(prev => prev.filter(t => t.id !== id));

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}

      {/* Toast Container */}
      <div
        className="fixed top-6 left-1/2 -translate-x-1/2 z-[9999] flex flex-col items-center gap-3 w-full max-w-sm px-4 pointer-events-none"
        dir="rtl"
      >
        {toasts.map(toast => {
          const style = ICONS[toast.type] || ICONS.info;
          return (
            <div
              key={toast.id}
              className="pointer-events-auto w-full flex items-center gap-3 bg-surface-container-lowest rounded-xl px-4 py-3.5 shadow-[0px_8px_32px_rgba(0,0,0,0.12)] border border-outline-variant/15 animate-slide-in"
            >
              {/* Icon */}
              <div className={`w-9 h-9 rounded-full flex-shrink-0 flex items-center justify-center ${style.bg}`}>
                <span
                  className={`material-symbols-outlined text-xl ${style.icon}`}
                  style={style.fill ? { fontVariationSettings: "'FILL' 1" } : {}}
                >
                  {style.symbol}
                </span>
              </div>

              {/* Message */}
              <p className="flex-1 text-sm font-semibold text-on-surface leading-snug">
                {toast.message}
              </p>

              {/* Dismiss */}
              <button
                onClick={() => dismiss(toast.id)}
                className="p-1 rounded-full hover:bg-surface-container transition-colors flex-shrink-0"
              >
                <span className="material-symbols-outlined text-outline text-lg">close</span>
              </button>
            </div>
          );
        })}
      </div>
    </ToastContext.Provider>
  );
};
